import { getDecimalNumbers, unTriggeredRuleResult, validateLength } from '../utils';
import { hasValue } from '../../internal';

/**
 * Validate the minimum number of decimal digits
 * @param {ValidationRuleParameters}  params  The rule parameters
 * @param {string | undefined}        value   The value that was entered
 */
export const minDecimalLengthRule = (params, value) => {
  if (typeof value !== 'string') {
    return unTriggeredRuleResult;
  }
  const decimalNumbers = getDecimalNumbers(value);
  const isInvalid = params.allowDecimal ? hasValue(decimalNumbers) && validateLength(decimalNumbers, params.decimalMinLength, 'lessThan') : false;
  const ruleResults = {
    validationState: {
      isValid: true,
      type: undefined,
      messageKey: 'lessThanMinDecimalDigits'
    },
    triggered: false
  };
  if (!isInvalid) {
    return ruleResults;
  }
  ruleResults.validationState.isValid = !isInvalid;
  ruleResults.triggered = isInvalid;
  ruleResults.validationState.message = params.customErrorMessages?.lessThanMinDecimalDigits || `${params.decimalMinLength} characters required after decimal`;
  ruleResults.validationState.type = 'error';
  return ruleResults;
};